<template>
    <div data-testid="client-results-page">
        <div class="card-header">
            <div class="row">
                <div class="col-md-2">
                    Filtrování
                </div>
                <div class="col-md-8 text-center">
                    <select v-model="assignedTo" class="mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" v-if="doctors.length > 0" data-testid="client-results-doctor-filter">
                        <option :value="null">všichni doktoři</option>
                        <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                    </select>

                    <button class="btn btn-sm btn-outline-danger" value="accepted" v-if="selectedStates.indexOf('accepted') < 0" @click="selectedStates.push('accepted')" data-testid="client-results-filter-accepted">nepřiřazené</button>
                    <button class="btn btn-sm btn-success" value="accepted" v-else="" @click="selectedStates.splice(selectedStates.indexOf('accepted'), 1)" data-testid="client-results-filter-accepted">nepřiřazené</button>

                    <button class="btn btn-sm btn-outline-danger" value="assigned" v-if="selectedStates.indexOf('assigned') < 0" @click="selectedStates.push('assigned')" data-testid="client-results-filter-assigned">nevyhodnocené</button>
                    <button class="btn btn-sm btn-success" value="assigned" v-else="" @click="selectedStates.splice(selectedStates.indexOf('assigned'), 1)" data-testid="client-results-filter-assigned">nevyhodnocené</button>

                    <button class="btn btn-sm btn-outline-danger" value="wait_for_doctor" v-if="selectedStates.indexOf('wait_for_doctor') < 0" @click="selectedStates.push('wait_for_doctor')" data-testid="client-results-filter-wait-for-doctor">předáno na doktora</button>
                    <button class="btn btn-sm btn-success" value="wait_for_doctor" v-else="" @click="selectedStates.splice(selectedStates.indexOf('wait_for_doctor'), 1)" data-testid="client-results-filter-wait-for-doctor">předáno na doktora</button>

                    <!-- <button class="btn btn-sm btn-outline-danger" value="elaborated" v-if="selectedStates.indexOf('elaborated') < 0" @click="selectedStates.push('elaborated')">rozdělané</button>
                    <button class="btn btn-sm btn-success" value="elaborated" v-else="" @click="selectedStates.splice(selectedStates.indexOf('elaborated'), 1)">rozdělané</button> -->

                    <button class="btn btn-sm btn-outline-danger" value="canceled" v-if="selectedStates.indexOf('completed') < 0" @click="selectedStates.push('completed')" data-testid="client-results-filter-completed">dokončeno</button>
                    <button class="btn btn-sm btn-success" value="canceled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('completed'), 1)" data-testid="client-results-filter-completed">dokončeno</button>
                </div>
                <div class="col-md-2 text-right">
                    <button @click="getDoctorsDayTasks()" class="btn btn-secondary btn-sm" data-testid="client-results-refresh"><i class="fa fa-refresh"></i></button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="listData.length > 0">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-sm-1"></th>
                    <th class="col-sm-2">Stav</th>
                    <th class="col-sm-3">Klient</th>
                    <th class="col-sm-3">Doktor</th>
                    <th class="col-sm-3">Datum přijetí</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(task, index) in listData" class="card-text">
                    <tr class="row m-0" :class="openedTaskId === task.id ? 'border border-primary border-bottom-0' : ''" :data-testid="'client-results-row-' + task.id">
                        <td class="align-middle col-sm-1">
                            <button class="btn btn-sm btn-primary" @click="openTaskId(task.id, task)" v-if="openedTaskId === task.id" :data-testid="'client-results-toggle-' + task.id">-</button>
                            <button class="btn btn-sm btn-secondary" @click="openTaskId(task.id, task)" v-else="" :data-testid="'client-results-toggle-' + task.id">+</button>
                            <!-- <visit-change-state v-on:update="getDoctorsDayTasks" :actual-state="task.state" :selected-doctor-id="task.planned_for.id" :visit-id="task.id"></visit-change-state> -->
                        </td>
                        <td class="align-middle col-sm-2" :data-testid="'client-results-state-' + task.id">
                            {{ task.state | taskStateToCS }}

                        </td>
                        <td class="col-sm-3" :data-testid="'client-results-client-' + task.id">

                        </td>
                        <td class="col-sm-3" :data-testid="'client-results-doctor-' + task.id">
                            {{ task.assigned_to ? task.assigned_to.fullname : '' }}
                        </td>
                        <td class="col-sm-3" :data-testid="'client-results-received-' + task.id">
                            {{ task.received_on }}
                        </td>
                    </tr>
                    <tr class="row m-0 border border-primary border-top-0 border-bottom-0" v-if="openedTaskId === task.id" :data-testid="'client-results-client-info-' + task.id">
                        <td class="col-md-12">
                            {{ task.client_info_line }}
                        </td>
                    </tr>
                    <tr class="row m-0 border border-primary border-top-0" v-if="openedTaskId === task.id" :data-testid="'client-results-detail-' + task.id">
                        <td class="col-md-6">
                            <b class="p-4">Laboratorní výsledek</b>
                            <!-- <button class="btn btn-sm btn-warning mr-2" @click="editMedicalReportId(mr.id, mr)"><i class="fa fa-pencil" aria-hidden="true"></i> upravit</button>-->
                            <a class="btn btn-sm btn-primary" target="_blank" role="button" :href="hostname.hostname + 'result/' + task.id + '/pdf'" :data-testid="'client-results-print-' + task.id"><i class="fa fa-print"></i> Tisknout</a>
                            <button class="btn btn-sm btn-primary" @click="putResult(task.id)" v-if="sendResultPending === false" :data-testid="'client-results-resend-' + task.id"><i class="fa fa-mail-forward" aria-hidden="true"></i> Odeslat e-mailem</button>
                            <button class="btn btn-sm btn-primary disabled" disabled="disabled" v-else=""><i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i> Odeslat e-mailem</button>

                            <div style="white-space: pre-wrap; font-family: monospace, monospace; font-size: medium;" class="p-4" id="result_text" v-html="task.result" :data-testid="'client-results-content-' + task.id">

                            </div>
                        </td>
                        <td class="col-md-6">
                            <template v-if="task.state === 'completed'">
                                Zpráva odeslaná klientovi:<br><br>
                                <p :data-testid="'client-results-evaluation-' + task.id">
                                    <b>
                                        {{ task.evaluation }}
                                    </b>
                                </p>
                            </template>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <pagination-component :list-pagination="listPagination" @set-page="setPage"/>
        </div>
        <div class="card-body" v-else-if="listPending">
            <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                (načítám)
            </div>
        </div>
        <div class="card-body" v-else="" data-testid="client-results-empty">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (nebyl nalezen žádný výsledek dle požadavků)
            </div>
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import moment from 'moment'
  import PaginationComponent from '@/components/PaginationComponent.vue'
  // import TaskChangeDoctor from '../components/TaskChangeDoctor.vue'
  // import TaskChangeState from '../components/TaskChangeState.vue'

  import Datepicker from 'vuejs-datepicker'

  export default {
    data () {
      return {
        visits_header_title: '',
        hostname: require('@/variables.js'),
        getParams: {
          p: 1,
          s: 'received_on-',
          f: {
          },
          pp: 20
        },
        selectedStates: [],
        print_date: '',
        assignedTo: '', // localStorage.getItem('userid'),
        doctors: [],
        doctorsPending: false,
        doctorsError: false,
        selectedDoctorId: null,
        showDoctorModal: false,
        selectedDate: '',
        listData: false,
        listError: false,
        listPagination: null,
        listPending: false,
        editingTaskId: false,
        editingTask: {},
        waitForSave: false,
        openedTaskId: false,
        openedTaskEvaluation: '',
        updatedTask: {
          evaluation: '',
          state: '',
          client_id: false,
          include_result_to_email: true
        },
        selected: '',
        clients: [],
        clientsPending: false,
        clientsError: false,
        state: '',
        sendResultPending: false
      }
    },
    mixins: [apiMixin],
    methods: {
      setPage (number) {
        this.getParams.p = number
        this.getDoctorsDayTasks()
      },
      openTaskId (num, result) {
        if (this.openedTaskId === num) {
          this.openedTaskId = false
          this.openedTaskEvaluation = ''
        } else {
          this.openedTaskId = num
          // this.openedTaskEvaluation = result.evaluation
          this.updatedTask = {
            evaluation: result.evaluation,
            state: result.state,
            client_id: result.client_id,
            include_result_to_email: true
          }
        }
      },
      getDoctorsDayTasks () {
        this.getResults(this.getParams)
      },
      moment: function (date) {
        return moment(date)
      },
      showModalChangeTaskDoctor (selectedDoctorId) {
        this.selectedDoctorId = selectedDoctorId
        this.showModal('visit-change-doctor')
      },
      showModal (name) {
        console.log('zobrazuji modal')
        this.$modal.show(name)
      },
      selectClient (value) {
        // console.log('oteviram klienta' + value.id)
        this.updatedTask.client_id = value.id
        this.updatedTask.state = 'assigned'
      },
      getResult (text) {
        // loading(true)
        if (text.length > 2) {
          this.searchClients(text)
        }
      },
      putResult (resultId) {
        let params = {
          include_result_to_email: true,
          dont_send_email: false
        }
        this.sendResultPending = true
        this.$http.put('result/' + resultId, params, {emulateJSON: true}).then(response => {
          this.sendResultPending = false
        }, response => {
          this.errors = response.data.errors
          this.sendResultPending = true
        })
      }
    },
    beforeMount () {
      this.getDoctors()
      moment.locale('cs')
      this.selectedStates = ['completed']
      this.getParams.f.client = this.$route.params.clientid
      this.getDoctorsDayTasks()
    },
    watch: {
      selectedStates: function (val) {
        this.getParams.f.state = val
        this.getDoctorsDayTasks()
      },
      assignedTo: function (val) {
        if (val === null) {
          delete this.getParams.f.assigned_to
        } else {
          this.getParams.f.assigned_to = val
        }

        this.getDoctorsDayTasks()
      },
      selectedDate: function (val) {
        localStorage.setItem('home_date', moment(val).format('DD.MM.YYYY'))
        this.selected_date = moment(val)
        this.setDateAndLoad()
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          this.getParams.f.client = to.params.clientid
          this.getDoctorsDayTasks()
        }
      }
    },
    components: {
      PaginationComponent,
      Datepicker
    },
    filters: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientResult.vue?09c76b49